export enum DirectionTypes {
  IncomingAndOutgoing = 'All',
  Outgoing = 'Outgoing',
  Incoming = 'Incoming',
}
